import React, {
    Fragment, useState, useContext, useEffect,
} from 'react';
import { createPortal } from 'react-dom';
import $ from 'jquery';
import Tippy from '@tippyjs/react';
import moment from 'moment';
import { addSuccessMessage } from '../../utilities/notificationUtilities';
import {
    getApiPageVerificationsUrl,
    getApiLinkVerificationSchedule,
    getApiVerificationSchedulesUrl,
    getCategoryUrl,
    getPageUrlFromSlug,
    getSubcategoryUrl,
    getUpgradePlanUrl,
} from '../../utilities/urlHelper';

import AnalyticsPageDropDown from './AnalyticsPageDropDown';
import { DynamicCaret } from '../GenericCarets';
import { hasVerificationFeature } from '../../utilities/featureHelper';
import PagePreviewModal from './PagePreviewModal';
import TimeWrapper from '../TimeWrapper';
import VerifyLinkWrapper from '../Links/VerfyLinkModal';
import { RESOURCE_TYPE, VERIFICATION_TYPE } from '../../utilities/CONSTANTS';
import useUsers from '../../hooks/useUsers';
import ViewerAvatar from '../ViewerAvatar';
import { CreateOrEditLinkVerificationWrapper, ViewLinkVerificationWrapper } from '../LinkVerificationWrapper';
import { canDeleteVerificationSchedule, canUpdateVerificationSchedule } from '../../utilities/permissionsUtilities';

export const VerificationListContext = React.createContext();

const PageIcon = () => (
    <img
        src="/img/icons/verification-icon.svg"
        className="page-list-icon"
        alt="Page icon"
    />
);

const LinkIcon = () => (
    <img
        src="/img/icons/verification-link-icon.png"
        className="page-list-icon"
        alt="Link icon"
    />
);

const Location = ({ item }) => (
    <Fragment>
        {item.category && <a href={getCategoryUrl(item.category_id)} className="gray">{item.category.name}</a>}
        {item.folder && (
            <Fragment>
                {' / '}
                <a href={getSubcategoryUrl(item.folder_id)} className="gray">{item.folder.name}</a>
            </Fragment>
        )}
    </Fragment>
);

const UpgradeAccount = (props) => (
    <div className="center">
        <i>To add page verifications</i>
        <Tippy content="Upgrade to a paid plan to use page verifications" placement="bottom">
            <a href={getUpgradePlanUrl()} className="btn-tertiary ml1 btn-teal upgrade-button">Upgrade</a>
        </Tippy>
    </div>
);

const LinkDropDown = props => {

    const verificationList = useContext(VerificationListContext);
    const [showModalView, setShowModalView] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { link } = props;
    const { canVerify } = props;
    const [isDeleting, setIsDeleting] = useState(false);

    const deleteHandler = () => {
        const url = getApiLinkVerificationSchedule(link.id, link.verification_schedule_id);
        const type = 'DELETE';
        if (isDeleting) return;
        setIsDeleting(true);
        $.ajax({ url, type })
            .then(() => {
                setIsDeleting(false);
                addSuccessMessage('Verification deleted');
                if (verificationList) {
                    const verifications = verificationList.verifications.filter(v => v.verification_schedule_id !== link.verification_schedule_id && v.id !== link.id);
                    verificationList.setVerifications(verifications);
                }
            });
    };
    return (
        <div className="dropdown dropdown-right-aligned right">
            <button className="page-list-dropdown dropdown-link">
                <img className="button-icon" src="/img/icons/dropdown-elipsis.svg" />
                <div className="dropdown-arrow" style={{ display: 'none' }} />
            </button>
            <div className="dropdown-overlay" style={{ display: 'none' }} />
            <div className="dropdown-content no-select" style={{ display: 'none' }}>
                <a
                    href={link.url}
                    className="dropdown-option"
                    target={link.resource_type === RESOURCE_TYPE.TETTRA_PAGE ? '_self' : '_blank'}
                    rel="noreferrer"
                >
                    View link
                </a>
                <ViewLinkVerificationWrapper
                    showModal={showModalView}
                    setShowModal={setShowModalView}
                    {...link}
                />
                {canUpdateVerificationSchedule() && (
                    <CreateOrEditLinkVerificationWrapper
                        showModal={showModal}
                        setShowModal={setShowModal}
                        {...link}
                        setVerificationScheduleIdAndClose={() => setShowModal(false)}
                    />
                )}
                {(canUpdateVerificationSchedule() || canVerify)
                    && (
                        <VerifyLinkWrapper
                            onlyVerify
                            canVerify={canVerify}
                            afterVerification={(id) => props.verify(id)}
                            link={link}
                        />
                    )}
                {canDeleteVerificationSchedule()
                    && <span style={{ color: '#CE0E0D' }} className="link dropdown-option" onClick={deleteHandler}>Remove verification</span>}
            </div>
        </div>
    );
};

const TableVerificationScheduleRow = props => {

    const [showPageModal, setShowPageModal] = useState(false);

    const clickPageTitle = (e) => {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault();

        return setShowPageModal(true);
    };

    const { verificationSchedule } = props;
    const users = useUsers();
    const assigneeIds = [];
    const assigneesArr = verificationSchedule.type === VERIFICATION_TYPE.LINK ? verificationSchedule.verification_schedule.link_verification_assignee
        : verificationSchedule.verification_schedule.verification_assignee;
    assigneesArr.forEach((item, key) => {
        assigneeIds.push(item.assignee_id);
    });
    const assignees = users && users.filter(u => (assigneeIds.includes(u.id)));

    const canVerify = assigneeIds.includes(window.userId);

    return (
        <Fragment>
            <tr>
                <td className="flex">
                    {verificationSchedule.type === VERIFICATION_TYPE.PAGE && <PageIcon />}
                    {verificationSchedule.type === VERIFICATION_TYPE.LINK && <LinkIcon />}
                    {verificationSchedule.type === VERIFICATION_TYPE.PAGE
                    && (
                        <a
                            href={getPageUrlFromSlug(verificationSchedule.slug)}
                            className="page-list-title bold"
                            onClick={clickPageTitle}
                        >
                            {verificationSchedule.title}
                        </a>
                    )}
                    {verificationSchedule.type === VERIFICATION_TYPE.LINK
                    && (
                        <a
                            href={verificationSchedule.url}
                            className="page-list-title bold"
                            target={verificationSchedule.resource_type === RESOURCE_TYPE.TETTRA_PAGE ? '_self' : '_blank'}
                            rel="noreferrer"
                        >
                            {verificationSchedule.title}
                        </a>
                    )}
                </td>
                <td className="gray sm-show-table-cell">
                    <Location item={verificationSchedule} />
                </td>
                <td className="gray xl-show-table-cell">
                    {verificationSchedule.lastVerified !== null
                        ? (
                            <TimeWrapper time={verificationSchedule.lastVerified}>
                                {verificationSchedule.lastVerified.local().fromNow()}
                            </TimeWrapper>
                        )
                        : 'Not verified yet'}
                </td>
                <td className="gray xl-show-table-cell">
                    { assignees?.map(assignee => <ViewerAvatar userId={assignee.id} tooltipPrefix="Assigned to " you={assignee.id === window.userId} key={`assignee-${assignee.id}`} />)}
                </td>
                <td className="gray sm-show-table-cell">
                    {verificationSchedule.nextVerifyDue !== null
                        ? <TimeWrapper time={verificationSchedule.nextVerifyDue}>{verificationSchedule.nextVerifyDue.local().fromNow()}</TimeWrapper>
                        : 'Now'}
                </td>
                <td>
                    {verificationSchedule.type === VERIFICATION_TYPE.PAGE && <AnalyticsPageDropDown page={verificationSchedule} canVerify={canVerify} verify={() => props.verify(verificationSchedule.id)} />}
                    {verificationSchedule.type === VERIFICATION_TYPE.LINK && <LinkDropDown link={verificationSchedule} canVerify={canVerify} verify={(id) => props.linkVerification(id)} />}
                </td>
            </tr>
            { showPageModal && createPortal(<PagePreviewModal page={verificationSchedule} closeModal={() => setShowPageModal(false)} />, document.body)}
        </Fragment>
    );
};

const SORT_ORDER = {
    NAME_ASC: 'NAME_ASC',
    NAME_DESC: 'NAME_DESC',
    LOCATION_ASC: 'LOCATION_ASC',
    LOCATION_DESC: 'LOCATION_DESC',
    LAST_VERIFIED_ASC: 'LAST_VERIFIED_ASC',
    LAST_VERIFIED_DESC: 'LAST_VERIFIED_DESC',
    NEXT_DUE_ASC: 'NEXT_DUE_ASC',
    NEXT_DUE_DESC: 'NEXT_DUE_DESC',
};

const getKey = item => `${item.type}-${item.id}`;

const VerificationsTable = props => {
    const [sortOrder, setSortOrder] = useState(SORT_ORDER.NEXT_DUE_DESC);
    const [selectedAssignee, setSelectedAssignee] = useState(false);

    const getOrderedVerifications = () => {
        const { verifications: allVerifications } = props;

        // Filtering on the base of selected assignee
        let verifications;
        if (selectedAssignee) {
            verifications = allVerifications.filter((item) => {
                const assigneesArr = item.type === VERIFICATION_TYPE.LINK ? item.verification_schedule.link_verification_assignee
                    : item.verification_schedule.verification_assignee;
                return assigneesArr.filter((assignee) => assignee.assignee_id === selectedAssignee).length;
            });
        } else {
            verifications = allVerifications;
        }

        if (sortOrder === SORT_ORDER.NAME_ASC) {
            return verifications.concat().sort((a, b) => (a.title.localeCompare(b.title)));
        } if (sortOrder === SORT_ORDER.NAME_DESC) {
            return verifications.concat().sort((a, b) => (b.title.localeCompare(a.title)));
        } if (sortOrder === SORT_ORDER.LOCATION_ASC) {
            return verifications.concat().sort((a, b) => {
                const aLoc = (a.category && a.category.name) || '';
                const bLoc = (b.category && b.category.name) || '';
                return aLoc.localeCompare(bLoc);
            });
        } if (sortOrder === SORT_ORDER.LOCATION_DESC) {
            return verifications.concat().sort((a, b) => {
                const aLoc = (a.category && a.category.name) || '';
                const bLoc = (b.category && b.category.name) || '';
                return bLoc.localeCompare(aLoc);
            });
        } if (sortOrder === SORT_ORDER.LAST_VERIFIED_ASC) {
            return verifications.concat().sort((a, b) => {
                if (!a.lastVerified) return 1;
                if (!b.lastVerified) return -1;
                return b.lastVerified.diff(a.lastVerified);
            });
        } if (sortOrder === SORT_ORDER.LAST_VERIFIED_DESC) {
            return verifications.concat().sort((a, b) => {
                if (!a.lastVerified) return -1;
                if (!b.lastVerified) return 1;
                return a.lastVerified.diff(b.lastVerified);
            });
        } if (sortOrder === SORT_ORDER.NEXT_DUE_ASC) {
            return verifications.concat().sort((a, b) => {
                if (!a.nextVerifyDue) return 1;
                if (!b.nextVerifyDue) return -1;
                return b.nextVerifyDue.diff(a.nextVerifyDue);
            });
        } if (sortOrder === SORT_ORDER.NEXT_DUE_DESC) {
            return verifications.concat().sort((a, b) => {
                if (!a.nextVerifyDue) return -1;
                if (!b.nextVerifyDue) return 1;
                return a.nextVerifyDue.diff(b.nextVerifyDue);
            });
        }

        return verifications;
    };

    const clickTableHeader = (desc, asc) => {
        if (sortOrder === asc) {
            return setSortOrder(desc);
        }
        return setSortOrder(asc);
    };

    const handleChange = (event) => {
        setSelectedAssignee(event.target.value ? parseInt(event.target.value) : false);
    };

    const users = useUsers();
    const options = users && users.map(user => ({ label: user.display_name, value: user.id }));
    const orderedVerifications = getOrderedVerifications();
    const verificationItemRows = orderedVerifications.map((item) => <TableVerificationScheduleRow key={getKey(item)} verificationSchedule={item} linkVerification={(id) => props.updateAfterVerification(id)} verify={props.verify} />);

    return (
        <Fragment>
            <div className="block col-12 mb2">
                <div className="dropdown-tab ">
                    <select onChange={handleChange} name="assignees" className="tab-select filter">
                        <option value="">Any Assignment</option>
                        {options && options.map((user) => <option key={user.value} value={user.value}>{user.label}</option>)}
                    </select>
                    <span className="sort-caret" />
                </div>
            </div>
            <div className="responsive-page-list-container">
                <table className="page-list">
                    <tbody>
                        <tr>
                            <th
                                className="th__sortable left-corner"
                                onClick={() => clickTableHeader(SORT_ORDER.NAME_DESC, SORT_ORDER.NAME_ASC)}
                            >
                                    Name
                                <DynamicCaret
                                    caretUp={SORT_ORDER.NAME_ASC}
                                    caretDown={SORT_ORDER.NAME_DESC}
                                    currentSortOrder={sortOrder}
                                />
                            </th>

                            <th
                                className="th__sortable nowrap sm-show-table-cell"
                                onClick={() => clickTableHeader(SORT_ORDER.LOCATION_DESC, SORT_ORDER.LOCATION_ASC)}
                            >
                                Location
                                <DynamicCaret
                                    caretUp={SORT_ORDER.LOCATION_ASC}
                                    caretDown={SORT_ORDER.LOCATION_DESC}
                                    currentSortOrder={sortOrder}
                                />
                            </th>

                            <th
                                className="th__sortable nowrap xl-show-table-cell"
                                onClick={() => clickTableHeader(SORT_ORDER.LAST_VERIFIED_DESC, SORT_ORDER.LAST_VERIFIED_ASC)}
                            >
                                Last verified
                                <DynamicCaret
                                    caretUp={SORT_ORDER.LAST_VERIFIED_DESC}
                                    caretDown={SORT_ORDER.LAST_VERIFIED_ASC}
                                    currentSortOrder={sortOrder}
                                />
                            </th>

                            <th className="nowrap xl-show-table-cell">
                                Assignee(s)
                            </th>

                            <th
                                className="th__sortable nowrap sm-show-table-cell"
                                onClick={() => clickTableHeader(SORT_ORDER.NEXT_DUE_DESC, SORT_ORDER.NEXT_DUE_ASC)}
                            >
                                Due
                                <DynamicCaret
                                    caretUp={SORT_ORDER.NEXT_DUE_DESC}
                                    caretDown={SORT_ORDER.NEXT_DUE_ASC}
                                    currentSortOrder={sortOrder}
                                />
                            </th>

                            <th className="th__actions" />
                        </tr>
                        {verificationItemRows}
                    </tbody>
                </table>
            </div>
        </Fragment>
    );
};

const LoadingState = () => <span className="gray loading">Loading verifications</span>;

const EmptyState = () => <div><span>No pages/links are under verification</span></div>;

const ErrorState = () => <div><span>Error getting pages/links</span></div>;

const VerificationList = (props) => {
    const [verifications, setVerifications] = useState(null);
    const [error, setError] = useState(false);

    const renameObjKey = (obj, oldKey, newKey) => {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
    };

    useEffect(() => {
        $.get(getApiVerificationSchedulesUrl())
            .done(({ links, pages }) => {
                const rawVerifications = pages.concat(links);
                const verificationsData = rawVerifications.map(verificationItem => {
                    if ('link_verification_schedule' in verificationItem) {
                        verificationItem.type = VERIFICATION_TYPE.LINK;
                        renameObjKey(verificationItem, 'link_verification', 'verification');
                        renameObjKey(verificationItem, 'link_verification_schedule', 'verification_schedule');
                        renameObjKey(verificationItem, 'link_verification_schedule_id', 'verification_schedule_id');
                        renameObjKey(verificationItem, 'link_verification_id', 'verification_id');
                    } else {
                        verificationItem.type = VERIFICATION_TYPE.PAGE;
                    }

                    verificationItem.lastVerified = verificationItem.verification ? moment.utc(verificationItem.verification.created_at) : null;

                    verificationItem.nextVerifyDue = verificationItem.verification
                        ? moment.utc(verificationItem.lastVerified).local().startOf('day').add(verificationItem.verification_schedule.days, 'days')
                        : null;

                    return verificationItem;
                });
                setVerifications(verificationsData);
            }).fail((e) => {
                if (e && e.statusText == 'abort') return;
                console.error(e);
                setError(true);
            });
    }, []);

    const verify = (pageId) => {
        const url = getApiPageVerificationsUrl(pageId);
        const data = { verifier_id: window.userId };

        $.ajax({
            type: 'POST',
            url,
            data,
        })
            .done(({ success }) => {
                if (!success) return;
                let verification = verifications.find(page => ((page.id === pageId) && page.type === VERIFICATION_TYPE.PAGE));
                verification.lastVerified = moment();
                verification.nextVerifyDue = moment().add(verification.verification_schedule.days, 'days');
                addSuccessMessage('Page verified');
                setVerifications(verifications);
            }).catch(console.error);
    };

    const updateAfterVerification = (linkId) => {
        let verification = verifications.find(link => ((link.id === linkId) && link.type === VERIFICATION_TYPE.LINK));
        verification.lastVerified = moment();
        verification.nextVerifyDue = moment().add(verification.verification_schedule.days, 'days');
        setVerifications(verifications);
    };

    if (error) return <ErrorState />;
    if (!verifications) return <LoadingState />;
    if (verifications.length == 0) return <EmptyState />;

    return (
        <VerificationListContext.Provider value={{ verifications, setVerifications }}>
            <VerificationsTable
                updateAfterVerification={(id) => updateAfterVerification(id)}
                verifications={verifications}
                verify={verify}
            />
        </VerificationListContext.Provider>
    );
};

export default (props) => (
    hasVerificationFeature()
        ? <VerificationList />
        : <UpgradeAccount />
);
